import { asMultiStyleConfig } from '../../../../utils/theme';
var parts = ['container', 'heading', 'button'];
var baseStyle = {
  container: {
    maxHeight: '14.375rem',
    overflowY: 'auto',
    padding: '0.3125rem'
  },
  heading: {
    marginBottom: {
      base: '2rem',
      md: '1rem'
    }
  },
  button: {
    textAlign: {
      base: 'center',
      md: 'right'
    }
  }
};
export var ExpandableParagraph = asMultiStyleConfig({
  parts,
  baseStyle
});